import { Trans } from 'react-i18next';

const API_ERRORS = {
  AccountSetupIssue: {
    title: 'Account Setup Issue',
    message: (
      <Trans
        i18nKey="apiErrors.accountSetupIssue"
        components={{
          b: <b />,
          a: (
            <a href="mailto:enterprise-b2b-support@1800flowers.com">
              Enterprise-B2B-Support@1800FLOWERS.com
            </a>
          )
        }}
      />
    )
  },
  AlreadySubscribed: {
    title: 'Oops, it looks like you’ve already subscribed!',
    message: 'Your information is currently associated with an existing plan.'
  },
  AutomationActivityNotFound: {
    title: '',
    message: ''
  },
  AutomationIsNotActive: {
    title: 'Automation inactive',
    message:
      'This automation is not active. You must reactive this automation in order to send email reminders to recipients.'
  },
  AutomationNotFound: {
    title: 'Automation not found',
    message: 'The automation you’re looking for either doesn’t exist, or has restricted access.'
  },
  AuthorizationFailure: {
    title: 'Payment declined',
    message:
      'Your one-time gift is ready to send, but the payment was declined. Please try again or update your payment method.',
    type: 'modal'
  },
  BadRequest: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{
          b: <b />,
          a: <a href="mailto:support@smartgift.com">Customer Support</a>
        }}
      />
    )
  },
  ClientAppNotFound: {
    title: '',
    message: ''
  },
  ContactDefinitionIsMissing: {
    title: 'Don’t forget to add recipients!',
    message: 'Add recipients to this gift by selecting contacts from the table on the left.'
  },
  ContactExistsWithSameEmail: {
    title: 'Duplicate email detected',
    message:
      'The email address you entered is associated with an existing contact – would you like to replace the existing contact with this new one?'
  },
  Default: {
    title: 'Something went wrong!',
    message: 'Please try again later.'
  },
  EstimatedChargeCalculationError: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.estimatedChargeCalculationError"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  InsufficientFund: {
    title: 'Insufficient funds',
    message: (
      <Trans
        i18nKey="apiErrors.insufficientFund"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    ),
    type: 'modal'
  },
  IntegrationError: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  InternalServerError: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  InvalidAuthProvider: {
    title: "Oops, it looks like this information isn't valid!",
    message: "The information you've provided does not match our current records. Please try again."
  },
  InvalidEmailOrPassword: {
    title: 'Invalid email or password',
    message:
      'The email address and/or password you entered don’t match our records – please check for any spelling errors and try again.'
  },
  InvalidInput: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  InvalidOrderProvider: {
    title: "Oops, it looks like this information isn't valid!",
    message: "The information you've provided does not match our current records. Please try again."
  },
  InvalidPaymentProvider: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  InvalidShareVia: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  InvalidSubscriptionToken: {
    title: '',
    message: ''
  },
  InvalidUserVerificationCode: {
    title: 'Invalid verification code',
    message:
      'The verification code you entered doesn’t match our records – please make sure it matches the code you received and try again.'
  },
  InvalidVendorProvider: {
    title: 'Internal system error',
    message: (
      <Trans
        i18nKey="apiErrors.badRequest"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  MagentoError: {
    title: 'Internal B2B System Error',
    message: (
      <Trans
        i18nKey="apiErrors.magentoError"
        components={{
          b: <b />,
          a: (
            <a href="mailto:enterprise-b2b-support@1800flowers.com">
              Enterprise-B2B-Support@1800FLOWERS.com
            </a>
          )
        }}
      />
    )
  },
  MagentoNetworkError: {
    title: 'Internal B2B Network Error',
    message: (
      <Trans
        i18nKey="apiErrors.magentoNetworkError"
        components={{
          b: <b />,
          a: (
            <a href="mailto:enterprise-b2b-support@1800flowers.com">
              Enterprise-B2B-Support@1800FLOWERS.com
            </a>
          )
        }}
      />
    )
  },
  MissingMagentoAccount: {
    title: 'Internal data error',
    message: (
      <Trans
        i18nKey="apiErrors.missingMagentoAccount"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  NoAvailableProducts: {
    title: 'Items out-of-stock',
    message:
      'All of the items you selected are out-of-stock. Please select different items to continue.'
  },
  NoExpirationDate: {
    title: 'Missing end date',
    message: 'Please enter the date when you would like this one-time gift to end.'
  },
  NotAuthenticated: {
    title: 'Authentication needed',
    message: (
      <Trans
        i18nKey="apiErrors.notAuthenticated"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  PONumberIsEmpty: {
    title: 'PO number is missing',
    message: 'Please update the PO number to continue.'
  },
  CostCenterIsEmpty: {
    title: 'Cost center is missing',
    message: 'Please update the cost center to continue.'
  },
  NotAuthorized: {
    title: 'Unauthorized request',
    message: (
      <Trans
        i18nKey="apiErrors.notAuthorized"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  NotFound: {
    title: 'Page not found',
    message: 'We’re sorry, but we couldn’t find the page you’re looking for.'
  },
  OrganizationAlreadyPendingForApproval: {
    title: 'Organization already pending for approval',
    message: 'You already send a request to send a gift card. Please wait for the approval.'
  },
  OrganizationNotFound: {
    title: 'Organization not found',
    message: (
      <Trans
        i18nKey="apiErrors.organizationNotFound"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  PaymentError: {
    title: 'Payment Error',
    message: (
      <Trans
        i18nKey="apiErrors.paymentError"
        components={{
          b: <b />,
          a: (
            <a href="mailto:enterprise-b2b-support@1800flowers.com">
              Enterprise-B2B-Support@1800FLOWERS.com
            </a>
          )
        }}
      />
    )
  },
  PaymentMethodMissing: {
    title: 'Payment method missing',
    message: 'Please select an existing payment method, or add a new one from the drop-down menu.',
    type: 'modal'
  },
  PaymentMethodNotExist: {
    title: 'Payment method does not exist',
    message: 'Selected payment method does not exist. Please choose a different one.'
  },
  ProductDefinitionIsMissing: {
    title: 'Don’t forget to add gifts!',
    message: 'Add gifts to this recognition by selecting items from the product catalog.'
  },
  RecognitionIsLive: {
    title: 'Are you sure?',
    message:
      'Your recognition is live. Deleting it may prevent some recipients from redeeming their gifts. Are you sure you want to delete it?'
  },
  RecognitionIsNotActive: {
    title: 'Recognition ended',
    message:
      'This recognition is not active. You must reactive this recognition in order to send email reminders to recipients.'
  },
  RecognitionNotFound: {
    title: 'Recognition not found',
    message: (
      <Trans
        i18nKey="apiErrors.recognitionNotFound"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  PunchoutRecognitionCannotBeUpdated: {
    title: 'Unable to save changes',
    message:
      'The changes you’re trying to make will incur additional charges for this already approved one-time gift. Please reach out to your admin for help, or contact Customer Support.'
  },
  SkuNotFound: {
    title: 'Item not included',
    message: 'The item you are trying to redeem wasn’t included in this recognition.'
  },
  SubscriptionLimitExceeded: {
    title: '',
    message: ''
  },
  SubscriptionNotFound: {
    title: "We couldn't find the subscription you're looking for.",
    message: ''
  },
  TokenIsMissing: {
    title: 'Authentication needed',
    message: (
      <Trans
        i18nKey="apiErrors.notAuthenticated"
        components={{ b: <b />, a: <a href="mailto:support@smartgift.com">Customer Support</a> }}
      />
    )
  },
  UnsupportedFileFormat: {
    title: 'Invalid file format',
    message:
      'The file you’re trying to upload is in the wrong format – please try uploading it again as an XLSX, XLS, or CSV file.'
  },
  UserAlreadyExists: {
    title: 'Username already in use',
    message:
      'The username you entered is already associated with an existing account. Please choose a different username.'
  },
  UserExistenceCheckFailed: {
    title: 'User does not exist',
    message:
      'The user who created this recognition or automation has been deleted. You can duplicate it to go live.'
  },
  UserNotFound: {
    title: 'Username not found',
    message:
      'The username you entered doesn’t match our records – please check for any spelling errors and try again.'
  }
};

export { API_ERRORS };
